
const inputCheckboxes = document.querySelectorAll(".tabsearch-list-items .input-checkbox");
var location_path = location.pathname;
var current_url = window.location.href;
var current_url_without_query = window.location.href.split('?')[0];
var select_tag;

inputCheckboxes.forEach(function (checkbox) {
  checkbox.addEventListener("change", function () {
    var this_tag = checkbox.getAttribute("value");
    
    selectedTags();
    clearUrlParameter();
    
  });
  checkbox.addEventListener("keydown", function (event) {
    if(event.keyCode == 13) {
      if($(this).prop('checked') == true) {
        $(this).prop("checked", false);
      } else {
        $(this).prop("checked", true);
      }
    }
  });
});

const clearUrlParameter = () => {
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  console.log("path:", window.location.pathname);
  if (history.pushState) {
    if (window.location.href.indexOf("page=") >= 0) {
      let searchParams = new URLSearchParams(window.location.search);
      let newurl = window.location.protocol + "//" + window.location.host + window.location.pathname;
      window.history.pushState({path: newurl}, '', newurl);
    }
  }
};

const selectedTags = () => {
  var selectedCheckboxes = document.querySelectorAll(".tabsearch-list-items .input-checkbox:checked");
  select_tag = '';
  selectedCheckboxes.forEach(function (selectedCheckbox, index) {
    select_tag = select_tag + selectedCheckbox.getAttribute("value") + (selectedCheckboxes.length - 1 === index ? '' : '+' );
  });
  
  var apiUrl;
  if(selectedCheckboxes.length > 0 ) {
    apiUrl = current_url_without_query + '/tagged/' + select_tag;
  }else{
    apiUrl = current_url_without_query;
  }

  fetch(apiUrl)
  .then(response => response.text())
  .then(data => {
    var newElement = document.createElement('div');
    newElement.innerHTML = data;
    var content = newElement.querySelector('.blog-tabcontent').innerHTML;
    document.querySelector('.blog-tabcontent').innerHTML = content;
  })
  .catch(error => {
    console.error('Fetch error:', error);
  });
};
